import { Component, OnInit } from '@angular/core';
import { ApisService } from 'src/app/service/APIs/apis.service';
import { AlertServiceService } from 'src/app/service/alert/alert-service.service';

@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.scss'],
})
export class CareersComponent implements OnInit {
  constructor(
    private apiService: ApisService,
    private alert: AlertServiceService
  ) {}

  jobOpenings() {
    this.alert.showInfo('No current job opening at the moment');
  }

  ngOnInit(): void {}
}
